import { cancelPendingRequest, client } from '@/api/client'
import type { ActionPlanInput } from '@/types/calculation'

/**
 * Posts to the proxy route on the corporate website, registered in
 * net-metering/_config/config.yml. Fixed and same origin, so it is not configurable from the CMS.
 * Trailing slash for the same reason as the calculation: without it the POST is redirected.
 */
export async function requestActionPlan(input: ActionPlanInput): Promise<void> {
  await client.post('/api/net-metering/action-plan/', input, {
    signal: cancelPendingRequest('net-metering.action-plan'),
  })
}
